import { FC, SyntheticEvent, useEffect, useState } from "react";
import SectionHeader from "../Layout/SectionHeader";

import classes from "./Notifications.module.css";
import TabPanel from "@mui/material/Tabs";
import { Badge, Tab, Tabs } from "@mui/material";
import VoteResult from "./VoteResult";
import Button from "../UI/Button";
import BattleLose from "./BattleLose";
import BattleWin from "./BattleWin";
import { useSelector } from "react-redux";
import { userState } from "../../store/user";
import { VoteModelDocument } from "../votes/Vote";
import { BattleModelDocument } from "../image/Image";
import axios from "axios";
import { getLang, i18n } from "../../i18n";

interface VoteNotification {
  _id: string;
  createdAt: Date;
  voteID: VoteModelDocument;
}

interface BattleNotification {
  _id: string;
  createdAt: Date;
  battleID: BattleModelDocument;
}

interface Props {
  setNotificationsCount: React.Dispatch<React.SetStateAction<number>>;
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const Notifications: FC<Props> = ({ setNotificationsCount, setPopupImage }) => {
  const lang = getLang();
  const t = i18n.notifications[lang];

  const [value, setValue] = useState("battles");
  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [voteNotifications, setVoteNotifications] = useState<
    VoteNotification[]
  >([]);
  const [battleNotifications, setBattleNotifications] = useState<
    BattleNotification[]
  >([]);
  const handleTabChange = (
    e: SyntheticEvent<Element, Event>,
    tabIndex: any
  ) => {
    window.scrollTo({
      top: 31,
      behavior: "smooth",
    });
    setValue(tabIndex);
  };
  const deleteNotification = async (id: string) => {
    setScreenIsLoading(true);
    await axios
      .delete(`${API_URL}/notifications/one/${id.toString()}`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        getUserNotifications();
      })
      .catch((error) => {
        console.log(error);
        setScreenIsLoading(false);
      });
  };
  const deleteVotesNotifications = async () => {
    setScreenIsLoading(true);
    await axios
      .delete(`${API_URL}/notifications/votes`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        getUserNotifications();
      })
      .catch((error) => {
        console.log(error);
        setScreenIsLoading(false);
      });
  };
  const deleteBattlesNotifications = async () => {
    setScreenIsLoading(true);
    await axios
      .delete(`${API_URL}/notifications/battles`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        getUserNotifications();
      })
      .catch((error) => {
        console.log(error);
        setScreenIsLoading(false);
      });
  };
  const getUserNotifications = async () => {
    setScreenIsLoading(true);
    await axios
      .get(`${API_URL}/notifications`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${user.sessionToken}` },
      })
      .then((response) => {
        setVoteNotifications(response.data.votes);
        setBattleNotifications(response.data.battles);
        setNotificationsCount(
          response.data.votes.length + response.data.battles.length
        );
        setScreenIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setScreenIsLoading(false);
      });
  };
  useEffect(() => {
    console.log("notifications use effect");
    const getUserNotifications = async () => {
      await axios
        .get(`${API_URL}/notifications`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setVoteNotifications(response.data.votes);
          setBattleNotifications(response.data.battles);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    getUserNotifications();
  }, []);
  return (
    <>
      <SectionHeader label={t.sectionHeader} />
      {!screenIsLoading && (
        <section className={classes.notifications}>
          <Tabs
            variant="fullWidth"
            value={value}
            onChange={handleTabChange}
            className={classes.tabs}
          >
            <Tab
              value="battles"
              label={
                <Badge
                  badgeContent={
                    battleNotifications.length === 0
                      ? "0"
                      : battleNotifications.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  {t.battlesTab}
                </Badge>
              }
            />
            <Tab
              value="votes"
              label={
                <Badge
                  badgeContent={
                    voteNotifications.length === 0
                      ? "0"
                      : voteNotifications.length
                  }
                  color="primary"
                  className={classes.badge}
                >
                  {t.votesTab}
                </Badge>
              }
            />
          </Tabs>

          {value === "battles" && (
            <TabPanel value="battles">
              <div className="container">
                {battleNotifications.length > 0 && (
                  <div className={classes.list}>
                    {battleNotifications.map((notification) =>
                      (notification.battleID.winnerArtworkID ===
                        notification.battleID.artwork1ID &&
                        notification.battleID.user1ID === user._id) ||
                      (notification.battleID.winnerArtworkID ===
                        notification.battleID.artwork2ID &&
                        notification.battleID.user2ID === user._id) ? (
                        <BattleWin
                          setPopupImage={setPopupImage}
                          key={notification._id}
                          currentUserIndex={
                            notification.battleID.user1ID === user._id ? 0 : 1
                          }
                          refreshUserBattles={getUserNotifications}
                          deleteNotification={deleteNotification}
                          {...notification}
                        />
                      ) : (
                        <BattleLose
                          setPopupImage={setPopupImage}
                          key={notification._id}
                          currentUserIndex={
                            notification.battleID.user1ID === user._id ? 0 : 1
                          }
                          deleteNotification={deleteNotification}
                          {...notification}
                        />
                      )
                    )}
                  </div>
                )}
                {battleNotifications.length === 0 && (
                  <div className={classes.empty}>{t.noBattles}</div>
                )}
                {battleNotifications.length > 0 && (
                  <Button
                    label={t.clearAll}
                    onClick={deleteBattlesNotifications}
                  />
                )}
              </div>
            </TabPanel>
          )}

          {value === "votes" && (
            <TabPanel value="votes">
              <div className="container">
                {voteNotifications.length > 0 && (
                  <div className={classes.list}>
                    {voteNotifications.map((notification) => (
                      <VoteResult
                        key={notification._id}
                        deleteNotification={deleteNotification}
                        {...notification}
                      />
                    ))}
                  </div>
                )}
                {voteNotifications.length === 0 && (
                  <div className={classes.empty}>{t.noVotes}</div>
                )}
                {voteNotifications.length > 0 && (
                  <Button
                    label={t.clearAll}
                    onClick={deleteVotesNotifications}
                  />
                )}
              </div>
            </TabPanel>
          )}
        </section>
      )}
    </>
  );
};

export default Notifications;
